export default __webpack_public_path__ + "static/media/setion07_bg.21ce9205.jpg";